module.exports = __webpack_public_path__ + "img/finish_line.aaf1ec9c.svg";